import { FileImageTwoTone, FilePdfTwoTone, FileTwoTone } from '@ant-design/icons';
import moment from 'moment';
import React from 'react';
import {convertSecondWordToCaps} from '../../utils/customPipeUtil';

export const prepareConsentDetail = (consentDetailList: any[], selectedRecord: any): any => {
  const transactionList = consentDetailList?.map(({ transactionId, listOfFhirObjects = [] }: any, index: number): any => {
    const finalFhirObjectsToDisplay = listOfFhirObjects?.map((ele: any): any => {
      return prepareFhirData(ele);
    });
    const requesterHospitalName = getRequesterName(listOfFhirObjects);
    return { transactionId, requesterHospitalName, finalFhirObjectsToDisplay };
  });
  return {
    patientName: selectedRecord?.patientName || '',
    transactionList,
  };
};

const getRequesterName = (entireFhirObjList: any[] = []): any => {
  return entireFhirObjList?.map((ele: any): any => {
    try {
      const currentFhirObj = JSON.parse(ele);
      const orgEle = currentFhirObj?.entry?.find((entryObj: any): boolean => entryObj?.fullUrl?.includes('Organization'));
      if (orgEle) {
        return orgEle?.resource?.name;
      } else {
        return '';
      }
    } catch (e) {
      return '';
    }
  })?.[0] || '';
};

const prepareFhirData = (fhirObject: string): any => {
  try {
    const { entry = [] } = JSON.parse(fhirObject); // This will have multiple files that has to be shown
    const finalFetchedObject: any = {
      files: [],
      author: [],
      fhirStatus: '',
      fhirTitle: '',
      sectionUpdateDate: '',
      organizationName: '',
      reportType: '',
    };
    entry?.map(({ resource, fullUrl }: any): any => {
      if (fullUrl?.includes('DocumentReference')) {
        finalFetchedObject.files.push({
          fileId: resource?.id,
          fileName: resource?.content[0]?.attachment?.title || '',
          fileStatus: resource?.status,
        });
      } else if (fullUrl?.includes('Composition')) {
        finalFetchedObject.author = resource?.author;
        finalFetchedObject.fhirStatus = resource?.status;
        finalFetchedObject.fhirTitle = resource?.title;
        finalFetchedObject.sectionUpdateDate = resource?.date;
        finalFetchedObject.reportType = resource?.section?.map((ele: any): any => ele?.title)?.join(', ');
      } else if (fullUrl?.includes('Organization')) {
        finalFetchedObject.organizationName = resource?.name;
      }
    });
    return finalFetchedObject;
  } catch (e) {
    return {};
  }
};

export const getIconBasedOnFile = (fileName: string): any => {
  const ext = fileName?.split('.');
  const fileType = ext[ext.length - 1]?.toLowerCase();
  switch (fileType) {
    case 'pdf':
      return <FilePdfTwoTone twoToneColor="#E15554" style={{ fontSize: '18px' }} />;
    case 'jpg':
      return <FileImageTwoTone twoToneColor="#E15554" style={{ fontSize: '18px' }}  />;
    case 'png':
      return <FileImageTwoTone twoToneColor="#E15554" style={{ fontSize: '18px' }}  />;
    case 'jpeg':
      return <FileImageTwoTone twoToneColor="#E15554" style={{ fontSize: '18px' }}  />;
    default:
      return <FileTwoTone twoToneColor="#E15554" style={{ fontSize: '18px' }}  />;
  }
};

export const getDocumentList = (files: any = {}, isEdit: boolean = false): any => {
  const finalFileList: any[] = [];
  Object.keys(files).map((ele: any): any => {
    if (files[ele]?.length) {
      files[ele].map((file: any): any => {
        const FileObj = {
          documentType: [ele],
          display: file.name,
          referenceNumber: file?.response?.uploadedDetails[0]?.fileGuid,
        };
        if (isEdit) {
          FileObj['linked'] = file.linked ? file.linked : false;
        }
        finalFileList.push(FileObj);
        return file;
      });
    }
    return ele;
  });
  return finalFileList;
};

export const getSentenceCase = (value: string): string => {
  return convertSecondWordToCaps(value.split('_').join(' '));
};

const todayDate = moment().startOf('day');

export const dateDisabledBeforeToday = (current: any): boolean => todayDate?.isAfter(moment(current), 'day');
export const dateDisabledAfterToday = (current: any): boolean => todayDate?.isBefore(moment(current), 'day');
export const dateDisabledSameOrBefore = (current: any): boolean => todayDate?.isSameOrBefore(moment(current), 'day');
